import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const collaborate_history = apiUrl + "/collaborate_history";
const routes = {
  label: "Collaborate History",
  root: collaborate_history,
  get_mine_received: collaborate_history + "/get_mine_received",
  get_mine_sent: collaborate_history + "/get_mine_sent",
};
export const Collaborate_History = {
  label: routes.label,
  get_mine_received: () => postWithToken(routes.get_mine_received),
  get_mine_sent: () => postWithToken(routes.get_mine_sent),
};
